<mat-toolbar
  fxLayout="row"
  fxLayoutAlign="center center"
  class="main-toolbar"
  style="background: white"
>
  <app-logo [size]="300"></app-logo>
</mat-toolbar>

<div class="payment-container">
  <ng-content></ng-content>
</div>
